import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Drawer, Affix, Menu } from "antd";
import Sidenav from "./Sidenav";
import Header from "./Header";
import Footer from "./Footer";
import axios from "axios";
import { message } from "antd";
import API from "../../api/url";
import { Redirect } from "react-router-dom";
import { useHistory } from "react-router-dom";

const { Header: AntHeader, Content, Sider } = Layout;

function Main({ children }) {
  const [visible, setVisible] = useState(false);
  const [placement, setPlacement] = useState("right");
  const [sidenavColor, setSidenavColor] = useState("#1890ff");
  const [sidenavType, setSidenavType] = useState("transparent");
  const [fixed, setFixed] = useState(false);

  const openDrawer = () => setVisible(!visible);
  const handleSidenavType = (type) => setSidenavType(type);
  const handleSidenavColor = (color) => setSidenavColor(color);
  const handleFixedNavbar = (type) => setFixed(type);

  let { pathname } = useLocation();
  const history = useHistory();
  pathname = pathname.replace("/", "");

  const token = localStorage.getItem("token");

  const profile = async () => {
    await axios.get(`${API.JS_PERKIM}me`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': "application/json",
        'Content-Type': "application/json"
      }
    })
    .then((response) => {
      if(response.statusText === "OK") {
        localStorage.setItem("user", JSON.stringify(response.data.data));
      }
    })
    .catch((error) => {
      if (error.response) {
        console.log("Error Main", error.response.data.message)
        message.error(error.response.data.message, 5);
        if(error.response.data.message === "Unauthenticated.") {
          localStorage.setItem("token", "");
          localStorage.setItem("isLogin", false);
          localStorage.setItem("user", "");
          // history.push("/sign-in");
        }
      } else if (error.request) {
        message.error('Network Error');
        localStorage.setItem("token", "");
        localStorage.setItem("isLogin", false);
        localStorage.setItem("user", "");
      } else {
        message.error(error.message);
        localStorage.setItem("token", "");
        localStorage.setItem("isLogin", false);
        localStorage.setItem("user", "");
      }
    })
  };
  
  useEffect(() => {
    profile();
  }, []);
  return localStorage.getItem("isLogin") == 'true' ? (
      <Layout
        className={`layout-dashboard ${
          pathname === "profile" ? "layout-profile" : ""
        } ${pathname === "rtl" ? "layout-dashboard-rtl" : ""}`}
      >
        <Drawer
          title={false}
          placement={placement === "right" ? "left" : "right"}
          closable={false}
          onClose={() => setVisible(false)}
          visible={visible}
          key={placement === "right" ? "left" : "right"}
          width={250}
          className={`drawer-sidebar ${
            pathname === "rtl" ? "drawer-sidebar-rtl" : ""
          } `}
        >
          <Layout
            className={`layout-dashboard ${
              pathname === "rtl" ? "layout-dashboard-rtl" : ""
            }`}
          >
            <Sider
              trigger={null}
              width={250}
              theme="light"
              className={`sider-primary ant-layout-sider-primary ${
                sidenavType === "#fff" ? "active-route" : ""
              }`}
              // style={{ background: sidenavType }}
            >
              <Sidenav color={sidenavColor} />
            </Sider>
          </Layout>
        </Drawer>
        <Sider
          breakpoint="lg"
          collapsedWidth="0"
          onCollapse={(collapsed, type) => {
            console.log(collapsed, type);
          }}
          trigger={null}
          width={250}
          theme="light"
          className={`sider-primary ant-layout-sider-primary ${
            sidenavType === "#fff" ? "active-route" : ""
          }`}
          // style={{ background: sidenavType }}
        >
          <Sidenav color={sidenavColor} />
        </Sider>
        <Layout>
          {fixed ? (
            <Affix>
              <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
                <Header
                  onPress={openDrawer}
                  name={pathname}
                  subName={pathname}
                  handleSidenavColor={handleSidenavColor}
                  handleSidenavType={handleSidenavType}
                  handleFixedNavbar={handleFixedNavbar}
                />
              </AntHeader>
            </Affix>
          ) : (
            <AntHeader className={`${fixed ? "ant-header-fixed" : ""}`}>
              <Header
                onPress={openDrawer}
                name={pathname}
                subName={pathname}
                handleSidenavColor={handleSidenavColor}
                handleSidenavType={handleSidenavType}
                handleFixedNavbar={handleFixedNavbar}
              />
            </AntHeader>
          )}
          <Content className="content-ant">{children}</Content>
          <Footer />
        </Layout>
      </Layout>
    ) : (<Redirect to="/sign-in" />);
}

export default Main;
